import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {setExtraOption, setStreamConfig} from "../../../redux/SettingsSlice";


const SkipCursor = ({cli}) => {

    const dispatch = useDispatch();
    const [skipCursor, setSkipCursor] = useState(true);


    const handleTouch = () => {
        setSkipCursor(false);
        return true;
    };

    const handleMouse = () => {
        setSkipCursor(true);
        return true;
    };

    useEffect(() => {
        dispatch(setExtraOption({optionName:"source", value:`--skip-cursor=${skipCursor}`}))

    }, [cli, skipCursor])

    useEffect(() => {
            if (skipCursor) { // when mouse is enabled - start listen to touch events
                document.addEventListener("touchstart", handleTouch, {passive: true});
                return () => document.removeEventListener("touchstart", handleTouch , {passive: true});
            } else { // when touch  is enabled - start listen to touch events
                document.addEventListener("mousemove", handleMouse, {once: true});
                return () => document.removeEventListener("mousemove", handleMouse , {once: true});
            }
        }
        , [skipCursor]);
    return
}

export default SkipCursor;